import { ObjectWith } from '../../cross-team-shared/types/misc';
import { AnswersByName } from './answers/answer';
import { ExtrasForOutput } from './outputs/output';
import { QuestionsByName } from './question';
import { SampleTask } from './sample-task';
import { Submission } from './submission';
import { User } from './user';

export type TaskState =
  | 'new'
  | 'rejected'
  | 'in progress'
  | 'completed'
  | 'approved'
  | 'delivered'
  | 'acknowledged';

export const calibrationInputKey = 'Calibration parameters';
export const cameraInitialRotationInputKey = 'Camera initial rotation';
export const locationsInputKey = 'Locations';
export const minInputKey = 'Min';
export const maxInputKey = 'Max';

export type ComputedInputName =
  | typeof cameraInitialRotationInputKey
  | typeof calibrationInputKey
  | typeof locationsInputKey
  | typeof minInputKey
  | typeof maxInputKey;

export interface TaskExternal {
  id: string;
  data: QuestionsByName;
  answers_or_gold: AnswersByName;
  next_internal_id: number;
  round: number;
  duration?: number;
  rej_reason?: string | string[];
  qa_feedback?: QaFeedback;
  sample_tasks?: SampleTask[];
  default_answers: AnswersByName;
  assets_archived_at: string | null;
  state?: TaskState;
  submissions?: Submission[];
  _extras?: TaskExtras;
  client_batch_identifier?: string;
}

export interface Task extends TaskExternal {
  _extras: TaskExtras;
}

export interface OutputExtras {
  [outputId: number]: ExtrasForOutput;
}

export enum TrainingTaskType {
  PRACTICE = 'PRACTICE',
  EVALUATION = 'EVALUATION',
}

export interface TaskExtras {
  urls_to_preload?: string[];
  signed_urls?: ObjectWith<string[]>;
  output_extras?: OutputExtras;
  rejection_history?: ObjectWith<RejectionHistory>;
  submitters?: UsersPerStep;
  training?: TaskTraining;
  message?: string;
  error_occurred?: boolean;
  previous_task?: Task;
}

export interface UsersPerStep {
  [stepId: number]: User;
}

export interface TaskTraining {
  type: TrainingTaskType;
  pass_mark: number | null;
  target_tpt: number | null;
  answers: AnswersByName;
}

export interface QaFeedback {
  comment: string | null;
  sample_task_id?: number | null;
  sampleId?: number;
}

export interface RejectionHistory {
  date: string;
  reasons: string[] | null;
  comments?: RejectionHistoryComments[];
}

interface RejectionHistoryComments {
  date: string;
  user?: string;
  comment?: string;
}
